import axios from '@/libs/api.request'
import config from '@/config'

export const getcompanyinfo = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/account/company/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationcompanyinfo = (data, meth) => {
  return axios.request({
    url: '/v1/account/company/',
    method: meth,
    data
  })
}

// WEB Socket
// export const webSocketUrl = 'ws://cmdb.opendevops.cn:8002/v1/cmdb/ws/terminal' 内网
// export const webSocketUrl = 'ws://demo.opendevops.cn/api/cmdb/v1/cmdb/ws/terminal' // 外网
const theDomain = process.env.NODE_ENV === 'development' ? 'demo.opendevops.cn' : config.domainName.pro
// const theDomain = process.env.NODE_ENV === 'development' ? config.domainName.dev : config.domainName.pro
const wsuri = '/v1/cmdb/ws/terminal'
const ws = config.isHttps ? 'wss' : 'ws'
export const webSocketUrl = ws + '://' + theDomain + '/api' + wsuri
